import { render, staticRenderFns } from "./AllergensAi.vue?vue&type=template&id=b59fedc6&scoped=true"
import script from "./AllergensAi.vue?vue&type=script&lang=ts"
export * from "./AllergensAi.vue?vue&type=script&lang=ts"
import style0 from "@/components/wellness/wellness-base.css?vue&type=style&index=0&id=b59fedc6&prod&scoped=true&lang=css&external"
import style1 from "./AllergensAi.vue?vue&type=style&index=1&id=b59fedc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59fedc6",
  null
  
)

export default component.exports